import dynamic from 'next/dynamic';
import A from './components/A';
import Header from './components/Header';
import css from './index.module.scss';

const IndexDynamic = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

export default function OverviewDE({ langKey }: any) {
    return (
        <div className={`power-ocean-collection ${css['power-ocean-collection']}`}>
            {langKey === 'solarspeicher' && <Header langKey={langKey} />}
            <A langKey={langKey} />
            <IndexDynamic langKey={langKey} />
        </div>
    );
}
